import {
	Component,
	Input,
	OnInit,
	Directive,
	OnDestroy,
	TemplateRef,
	ContentChild
} from '@angular/core';
import { DropdownService } from './dropdown.service';
import { Subscription } from 'rxjs';
import { DROPDOWN_TYPES } from './dropdown-types.enum';
import { DROPDOWN_ORIENTATION } from './dropdown-orientation.enum';

@Component({
	selector: 'ea-dropdown',
	templateUrl: './dropdown.component.html',
	styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit, OnDestroy {
	@Input() dropdownId: string;
	@Input() showArrow = false;
	@Input() dropdownType = DROPDOWN_TYPES.Menu;
	@Input() isActive = false;
	@Input() orientation = DROPDOWN_ORIENTATION.Right;
	@ContentChild('dropdownContent') dropDownContentTemplate: TemplateRef<any>;
	DROPDOWN_TYPES = DROPDOWN_TYPES;
	DROPDOWN_ORIENTATION = DROPDOWN_ORIENTATION;
	protected readonly subscriptions = new Subscription();

	constructor(protected readonly dropdownService: DropdownService) {}

	ngOnInit(): void {
		this.subscriptions.add(
			this.dropdownService.closeDropDownEvent.subscribe((dropdownId) => {
				if (dropdownId === this.dropdownId) {
					this.isActive = false;
				}
			})
		);

		this.subscriptions.add(
			this.dropdownService.openDropDownEvent.subscribe((dropdownId) => {
				if (dropdownId === this.dropdownId) {
					this.isActive = true;
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}

	toggleDropDown(): void {
		if (this.dropDownContentTemplate) {
			this.isActive = !this.isActive;
		}
	}

	overlayClick(): void {
		this.isActive = false;
	}
}

@Directive({
	//eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'ea-dropdown-button'
})
export class DropDownButtonDirective {}
